import { recordReachedAchievements, type AchievementDefinition } from './achievements.ts';
import { recordContractProgress } from './activities.ts';
import { recordReachedMilestones, type RealmMilestone } from './milestones.ts';
import type { GameState } from './types.ts';

export function recordProgress(state: GameState): {
  state: GameState;
  achievements: AchievementDefinition[];
  milestones: RealmMilestone[];
} {
  state = recordContractProgress(state);
  const milestoneResult = recordReachedMilestones(state);
  const achievementResult = recordReachedAchievements(milestoneResult.state);
  return { state: achievementResult.state, achievements: achievementResult.unlocked, milestones: milestoneResult.unlocked };
}
